let t = /* @__PURE__ */ function(o) {
  return o[o.Modal = 1500] = "Modal", o[o.Tooltip = 1700] = "Tooltip", o;
}({});
export {
  t as Z
};
//# sourceMappingURL=z-index-CEuzp1gH.mjs.map
